<template>
<div class="chapter">
<div class="inner_page">
<p><a id="cop"></a></p>
<div class="crt">This edition first published in the United States in 2005 by<br/> The Overlook Press, Peter Mayer Publishers, Inc.</div>
<div> <br/></div><div class="crt">141 Wooster Street <br/>New York, NY 10012 <br/><a href="http://www.overlookpress.com" target="_blank">www.overlookpress.com</a></div>
<div> <br/></div><div class="crt">For bulk and special sales, please contact sales@overlookny.com</div>
<div class="crt-copy"><div> <br/></div>Copyright © 2002 by Penny Vincenzi</div>
<div class="crt">All rights reserved. No part of this publication may be reproduced <br/>or transmitted in any form or by any means, electronic or mechanical, <br/>including photocopy, recording, or any information storage and retrieval <br/>system now known or to be invented, without permission in writing from the <br/>publisher, except by a reviewer who wishes to quote brief passages in connection <br/>with a review written for inclusion in a magazine, newspaper, or broadcast.</div>
<div> <br/></div><div class="crt">Cataloging-in-Publication Data is available from the Library of Congress</div>
<div> <br/></div><div class="crt">ISBN: 9781590208007</div>
<div> <br/></div><div class="crt">
<p class="crt"><a href="http://us.penguingroup.com" target="_blank">http://us.penguingroup.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vinc_9781590208007_oeb_cop_r1.vue?a9e31170